import { List, Record } from 'immutable'
import { ITenantRent, TenantRent } from './TenantRent'

export interface IListingFinancialDetails {
  readonly grossIncome: number
  readonly netIncome: number
  readonly rentDetails: List<ITenantRent>
}

const ListingFinancialDetailsRecord = Record({
  grossIncome: 0,
  netIncome: 0,
  rentDetails: List<TenantRent>(),
})

export class ListingFinancialDetails extends ListingFinancialDetailsRecord
  implements IListingFinancialDetails {
  public static fromJS(initialState?: Partial<IListingFinancialDetails>) {
    if (!initialState) {
      return new ListingFinancialDetails()
    }

    const { rentDetails, ...rest } = initialState

    return new ListingFinancialDetails({
      rentDetails: Array.isArray(rentDetails)
        ? List(rentDetails.map((r) => TenantRent.fromJS(r)))
        : List<TenantRent>(),
      ...rest,
    })
  }

  public readonly grossIncome: number
  public readonly netIncome: number
  public readonly rentDetails: List<TenantRent>

  constructor(props?: Partial<ListingFinancialDetails>) {
    props ? super(props) : super()
  }
}
